import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import systemAIIcon from "assets/images/system-ai.svg";
import { styled } from "@mui/material/styles";
import { css } from "@emotion/react";

type Props = {
  primaryText: string;
  secondaryText?: string;
};

const ProcessingStatusAlert: React.FC<Props> = ({ primaryText, secondaryText }) => {
  return (
    <StyledListItem>
      <ListItemIcon>
        <StyledImage src={systemAIIcon} alt={"System AI Icon"} />
      </ListItemIcon>
      <StyledListItemText
        primary={primaryText}
        secondary={secondaryText}
        primaryTypographyProps={{
          variant: "h3",
        }}
      />
    </StyledListItem>
  );
};

const StyledListItem = styled(ListItem)(
  ({ theme }) => css`
    padding: 12px;
    background: #e0f3ff;
    box-shadow: none;
    flex-wrap: nowrap;
    ${theme.mixins.flexGap("16px")}
  `
);

const StyledListItemText = styled(ListItemText)(
  ({ theme }) => css`
    margin: 0;
    color: ${theme.palette.text.primary};
  `
);

const StyledImage = styled("img")(
  ({ theme }) => css`
    width: 55px;
  `
);

export default ProcessingStatusAlert;
